type TFeatures = {
  flexbox: 'flexbox'
  serviceworker: 'serviceworker'
  webgl: 'webgl'
  push: 'push'
  notifications: 'notifications'
}

type TFeatureName = keyof TFeatures
const detectors: Partial<Record<TFeatureName, () => boolean>> = {
  flexbox: () => 'flex' in document.documentElement.style,
  serviceworker: () => 'serviceWorker' in navigator,
  webgl: () => {
    try {
      const canvas = document.createElement('canvas')
      return !!(canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
    } catch {
      return false
    }
  },
  push: () => 'PushManager' in window,
  notifications: () => 'Notification' in window,
}

export const detectFeature = (feature: TFeatureName): boolean =>
  typeof window !== 'undefined' && detectors[feature]?.() === true
